import React, { isValidElement } from 'react'

export type SidePanelFooterProps = {
  footer?: React.ReactNode
}

export const SidePanelFooter = ({
  footer
}: SidePanelFooterProps): JSX.Element | null => {
  if (!footer || !isValidElement(footer)) return null
  return <footer className="SidePanel-footer">{footer}</footer>
}
